import { PipeTransform } from '@angular/core';
import { format } from 'date-fns';
var ConcatDateAndTimePipe = /** @class */ (function () {
    function ConcatDateAndTimePipe() {
    }
    ConcatDateAndTimePipe.prototype.transform = function (_a) {
        var date = _a.date, time = _a.time;
        if (time) {
            var value = date + "T" + time;
            var formattedDate = format(new Date(value), 'dd/MM/yyyy HH:mm');
            return formattedDate;
        }
        return format(new Date(date), 'dd/MM/yyyy');
    };
    return ConcatDateAndTimePipe;
}());
export { ConcatDateAndTimePipe };
